import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "./use-accounts";

export function TryAnotherAccount() {
  const { t } = useI18n();
  const { accounts, activeUserId, switchTo } = useAccounts();

  const otherAccounts = () =>
    accounts().filter((a) => a.kind === "real" && a.userId !== activeUserId());

  return (
    <Show when={otherAccounts().length > 0}>
      <div class="mt-4 p-4 rounded-xl bg-muted/40 border border-border/50 text-sm space-y-2">
        <p class="text-muted-foreground font-medium">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap gap-2">
          <For each={otherAccounts()}>
            {(account) => (
              <button
                type="button"
                onClick={() => {
                  void switchTo(account.userId);
                }}
                class="px-3 py-1.5 rounded-lg bg-background hover:bg-accent border border-border text-foreground font-semibold transition-colors text-xs flex items-center gap-2 cursor-pointer shadow-xs"
              >
                <span>{account.displayName}</span>
                <Show when={account.email}>
                  <span class="text-muted-foreground font-normal">({account.email})</span>
                </Show>
              </button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
